var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDataAnalyticsPlattform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 405,
    viewBox: "0 0 701 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.294 303.934L392.53 283.287L394.245 282.297L430.009 302.944C434.784 305.7 437.466 309.439 437.466 313.338L437.466 331.437C437.466 335.335 434.784 339.074 430.009 341.831L402.818 357.528L401.103 356.538L428.294 340.841C432.614 338.347 435.041 334.964 435.041 331.437L435.041 313.338C435.041 309.81 432.614 306.428 428.294 303.934Z",
    fill: "#C6D6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.105 222.905L559.15 258.724L557.435 259.714L495.391 223.895L497.105 222.905Z",
    fill: "#C6D6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.865 269.289L426.82 263.49L428.535 262.5L438.579 268.299C443.354 271.056 446.037 274.794 446.037 278.693V286.893C446.037 290.792 443.354 294.531 438.579 297.287L419.962 308.035L418.247 307.045L436.865 296.297C441.185 293.803 443.612 290.421 443.612 286.893L443.612 278.693C443.612 275.166 441.185 271.783 436.865 269.289Z",
    fill: "#C6D6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.892 100.463C460.926 96.9093 458.496 93.4957 454.143 90.9832L435.582 80.2699L437.296 79.2799L455.858 89.9932C460.669 92.7702 463.355 96.5432 463.316 100.471L463.236 108.782C463.198 112.652 460.518 116.357 455.778 119.094L428.531 134.824L426.817 133.834L454.064 118.104C458.352 115.628 460.777 112.276 460.811 108.774L460.892 100.463Z",
    fill: "#C6D6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.285 139.971C183.084 139.972 177.144 141.416 172.81 143.976L154.525 154.78L152.791 153.802L171.075 142.998C175.866 140.168 182.431 138.572 189.285 138.571L203.327 138.571C210.08 138.571 216.557 140.119 221.333 142.876L239.95 153.624L238.235 154.614L219.618 143.866C215.298 141.372 209.437 139.971 203.327 139.971L189.285 139.971Z",
    fill: "#C6D6F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.589 105.991C249.589 102.411 252.09 98.9818 256.526 96.4797L275.24 85.9239L273.546 84.9226L254.831 95.4784C249.929 98.2439 247.164 102.034 247.164 105.991L247.163 114.098C247.162 117.996 249.845 121.736 254.62 124.492L273.237 135.24L274.952 134.25L256.335 123.503C252.014 121.008 249.587 117.625 249.588 114.098L249.589 105.991Z",
    fill: "#C6D6F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.099 145.137L193.053 108.74L194.768 107.75L257.814 144.147L256.099 145.137Z",
    fill: "#C6D6F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.393 105.121L359.953 134.818L358.239 133.828L409.679 104.131L411.393 105.121Z",
    fill: "#C6D6F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.39 105.125L394.243 115.024L392.529 114.034L409.675 104.135L411.39 105.125Z",
    fill: "#C6D6F8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.812 108.847L444.393 145.459L442.678 144.469L506.098 107.857L507.812 108.847Z",
    fill: "#C6D6F8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.655 223.895L143.52 259.766L141.805 258.776L203.94 222.905L205.655 223.895Z",
    fill: "#C6D6F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.18 248.504L238.224 242.705L239.939 243.695L229.895 249.493C225.12 252.25 218.644 253.799 211.891 253.799H197.686C190.933 253.799 184.457 252.25 179.682 249.493L161.065 238.745L162.779 237.756L181.397 248.504C185.717 250.998 191.576 252.399 197.686 252.399L211.891 252.399C218 252.399 223.86 250.998 228.18 248.504Z",
    fill: "#C6D6F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.868 248.504L462.824 242.705L461.109 243.695L471.154 249.494C475.929 252.251 482.405 253.799 489.158 253.799H503.362C510.115 253.799 516.591 252.251 521.366 249.494L539.984 238.746L538.269 237.756L519.652 248.504C515.331 250.998 509.472 252.399 503.362 252.399L489.158 252.399C483.048 252.399 477.188 250.998 472.868 248.504Z",
    fill: "#C6D6F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.641 148.815L529.686 154.614L531.4 153.624L521.356 147.825C516.581 145.069 510.105 143.52 503.352 143.52L489.148 143.52C482.395 143.52 475.919 145.069 471.144 147.825L461.099 153.624L462.814 154.614L472.858 148.815C477.178 146.321 483.038 144.92 489.148 144.92L503.352 144.92C509.462 144.92 515.321 146.321 519.641 148.815Z",
    fill: "#C6D6F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.188 269.289L274.232 263.49L272.518 262.5L262.473 268.299C257.698 271.056 255.016 274.794 255.016 278.693V286.893C255.016 290.792 257.698 294.531 262.473 297.287L281.091 308.035L282.806 307.045L264.188 296.297C259.868 293.803 257.441 290.421 257.441 286.893L257.441 278.693C257.441 275.166 259.868 271.783 264.188 269.289Z",
    fill: "#C6D6F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M529.077 188.531H171.98C171.979 192.364 171.98 197.386 171.98 200.977C172.569 204.518 174.328 205.814 179.08 208.558L333.381 297.637C342.851 303.104 358.205 303.104 367.674 297.637L521.976 208.558C526.708 205.826 528.484 204.861 529.077 200.977C529.077 196.796 529.077 190.937 529.077 188.531Z",
    fill: "url(#paint0_linear_8066_3061)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.079 198.66C169.609 193.193 169.609 184.329 179.079 178.862L333.38 89.7826C342.85 84.3156 358.204 84.3155 367.674 89.7825L521.975 178.862C531.445 184.329 531.445 193.193 521.975 198.66L367.674 287.739C358.204 293.206 342.85 293.206 333.381 287.739L179.079 198.66Z",
    fill: "url(#paint1_linear_8066_3061)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M494.783 158.018H206.23C206.231 171.479 206.037 179.634 206.036 185.069C206.338 192.522 207.852 194.597 213.347 197.769L333.374 267.061C342.843 272.528 358.197 272.528 367.667 267.061L487.693 197.769C493.186 194.599 494.783 192.695 494.783 185.125V158.018Z",
    fill: "url(#paint2_linear_8066_3061)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.35 168.074C203.88 162.607 203.88 153.743 213.35 148.276L333.376 78.9844C342.846 73.5174 358.2 73.5174 367.67 78.9844L487.696 148.276C497.166 153.743 497.166 162.607 487.696 168.074L367.67 237.366C358.2 242.833 342.846 242.833 333.376 237.366L213.35 168.074Z",
    fill: "url(#paint3_linear_8066_3061)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.507 156.344C151.638 157.574 151.638 159.568 149.507 160.798C147.376 162.028 143.922 162.028 141.791 160.798C139.66 159.568 139.66 157.574 141.791 156.344C143.922 155.113 147.376 155.113 149.507 156.344Z",
    fill: "#C6D6F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.647 162.035C154.962 160.122 154.962 157.02 151.647 155.106C148.333 153.193 142.959 153.193 139.644 155.106C136.33 157.02 136.33 160.122 139.644 162.035C142.959 163.949 148.333 163.949 151.647 162.035ZM153.362 163.025C157.623 160.565 157.623 156.576 153.362 154.116C149.1 151.656 142.191 151.656 137.93 154.116C133.668 156.576 133.668 160.565 137.93 163.025C142.191 165.485 149.1 165.485 153.362 163.025Z",
    fill: "#C6D6F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.221 261.264C141.352 262.495 141.352 264.489 139.221 265.719C137.091 266.949 133.636 266.949 131.505 265.719C129.375 264.489 129.375 262.495 131.505 261.264C133.636 260.034 137.091 260.034 139.221 261.264Z",
    fill: "#08FFA6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.361 266.956C144.676 265.043 144.676 261.941 141.361 260.027C138.047 258.114 132.673 258.114 129.359 260.027C126.044 261.941 126.044 265.043 129.359 266.956C132.673 268.87 138.047 268.87 141.361 266.956ZM143.076 267.946C147.338 265.486 147.338 261.497 143.076 259.037C138.815 256.577 131.906 256.577 127.644 259.037C123.383 261.497 123.383 265.486 127.644 267.946C131.906 270.406 138.815 270.406 143.076 267.946Z",
    fill: "#C6D6F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 232.064C161.068 233.294 161.068 235.288 158.938 236.518C156.807 237.748 153.352 237.748 151.222 236.518C149.091 235.288 149.091 233.294 151.222 232.064C153.352 230.834 156.807 230.834 158.938 232.064Z",
    fill: "#C6D6F8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.077 237.756C164.392 235.842 164.392 232.74 161.077 230.826C157.763 228.913 152.389 228.913 149.075 230.826C145.76 232.74 145.76 235.842 149.075 237.756C152.389 239.669 157.763 239.669 161.077 237.756ZM162.792 238.746C167.053 236.285 167.053 232.297 162.792 229.837C158.531 227.376 151.621 227.376 147.36 229.837C143.099 232.297 143.099 236.285 147.36 238.746C151.621 241.206 158.531 241.206 162.792 238.746Z",
    fill: "#C6D6F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.651 101.907C192.782 103.137 192.782 105.131 190.651 106.361C188.52 107.591 185.066 107.591 182.935 106.361C180.804 105.131 180.804 103.137 182.935 101.907C185.066 100.676 188.52 100.676 190.651 101.907Z",
    fill: "#08FFA6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.791 107.598C196.106 105.685 196.106 102.583 192.791 100.669C189.477 98.7557 184.103 98.7557 180.789 100.669C177.474 102.583 177.474 105.685 180.789 107.598C184.103 109.512 189.477 109.512 192.791 107.598ZM194.506 108.588C198.767 106.128 198.767 102.139 194.506 99.6793C190.244 97.2192 183.335 97.2192 179.074 99.6793C174.812 102.139 174.812 106.128 179.074 108.588C183.335 111.048 190.244 111.048 194.506 108.588Z",
    fill: "#C6D6F8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.677 78.5696C287.808 79.7997 287.808 81.794 285.677 83.0241C283.546 84.2542 280.092 84.2542 277.961 83.0241C275.83 81.794 275.83 79.7997 277.961 78.5696C280.092 77.3396 283.546 77.3396 285.677 78.5696Z",
    fill: "#08FFA6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.817 84.2615C291.131 82.348 291.131 79.2457 287.817 77.3323C284.503 75.4188 279.129 75.4188 275.814 77.3323C272.5 79.2457 272.5 82.348 275.814 84.2615C279.129 86.1749 284.503 86.1749 287.817 84.2615ZM289.532 85.2514C293.793 82.7912 293.793 78.8025 289.532 76.3424C285.27 73.8822 278.361 73.8822 274.1 76.3424C269.838 78.8025 269.838 82.7912 274.1 85.2514C278.361 87.7115 285.27 87.7115 289.532 85.2514Z",
    fill: "#C6D6F8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M421.277 97.4651C423.408 98.6952 423.408 100.69 421.277 101.92C419.146 103.15 415.692 103.15 413.561 101.92C411.43 100.69 411.43 98.6952 413.561 97.4651C415.692 96.2351 419.146 96.2351 421.277 97.4651Z",
    fill: "#C6D6F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.417 103.157C426.732 101.244 426.732 98.1412 423.417 96.2278C420.103 94.3143 414.729 94.3143 411.415 96.2278C408.1 98.1412 408.1 101.244 411.415 103.157C414.729 105.07 420.103 105.07 423.417 103.157ZM425.132 104.147C429.393 101.687 429.393 97.698 425.132 95.2379C420.87 92.7777 413.961 92.7777 409.7 95.2379C405.438 97.698 405.438 101.687 409.7 104.147C413.961 106.607 420.87 106.607 425.132 104.147Z",
    fill: "#C6D6F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.417 103.157C426.732 101.244 426.732 98.1412 423.417 96.2278C420.103 94.3143 414.729 94.3143 411.415 96.2278C408.1 98.1412 408.1 101.244 411.415 103.157C414.729 105.07 420.103 105.07 423.417 103.157ZM425.132 104.147C429.393 101.687 429.393 97.698 425.132 95.2379C420.87 92.7777 413.961 92.7777 409.7 95.2379C405.438 97.698 405.438 101.687 409.7 104.147C413.961 106.607 420.87 106.607 425.132 104.147Z",
    fill: "#C6D6F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M518.125 101.905C520.256 103.135 520.256 105.129 518.125 106.359C515.995 107.589 512.54 107.589 510.409 106.359C508.279 105.129 508.279 103.135 510.409 101.905C512.54 100.675 515.995 100.675 518.125 101.905Z",
    fill: "#08FFA6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.265 107.598C523.579 105.685 523.579 102.583 520.265 100.669C516.95 98.7557 511.577 98.7557 508.262 100.669C504.948 102.583 504.948 105.685 508.262 107.598C511.577 109.512 516.95 109.512 520.265 107.598ZM521.979 108.588C526.241 106.128 526.241 102.139 521.979 99.6793C517.718 97.2192 510.809 97.2192 506.548 99.6793C502.286 102.139 502.286 106.128 506.548 108.588C510.809 111.048 517.718 111.048 521.979 108.588Z",
    fill: "#C6D6F8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.265 107.598C523.579 105.685 523.579 102.583 520.265 100.669C516.95 98.7557 511.577 98.7557 508.262 100.669C504.948 102.583 504.948 105.685 508.262 107.598C511.577 109.512 516.95 109.512 520.265 107.598ZM521.979 108.588C526.241 106.128 526.241 102.139 521.979 99.6793C517.718 97.2192 510.809 97.2192 506.548 99.6793C502.286 102.139 502.286 106.128 506.548 108.588C510.809 111.048 517.718 111.048 521.979 108.588Z",
    fill: "#C6D6F8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M542.124 156.344C544.255 157.574 544.255 159.568 542.124 160.799C539.994 162.029 536.539 162.029 534.408 160.799C532.278 159.568 532.278 157.574 534.408 156.344C536.539 155.114 539.994 155.114 542.124 156.344Z",
    fill: "#C6D6F8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.264 162.038C547.578 160.125 547.578 157.023 544.264 155.109C540.949 153.196 535.576 153.196 532.261 155.109C528.947 157.023 528.947 160.125 532.261 162.038C535.576 163.952 540.949 163.952 544.264 162.038ZM545.978 163.028C550.24 160.568 550.24 156.579 545.978 154.119C541.717 151.659 534.808 151.659 530.547 154.119C526.285 156.579 526.285 160.568 530.547 163.028C534.808 165.488 541.717 165.488 545.978 163.028Z",
    fill: "#C6D6F8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M550.694 231.569C552.824 232.799 552.824 234.793 550.694 236.023C548.563 237.253 545.108 237.253 542.978 236.023C540.847 234.793 540.847 232.799 542.978 231.569C545.108 230.339 548.563 230.339 550.694 231.569Z",
    fill: "#C6D6F8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.834 237.263C556.148 235.349 556.148 232.247 552.834 230.334C549.519 228.42 544.145 228.42 540.831 230.334C537.517 232.247 537.517 235.349 540.831 237.263C544.145 239.176 549.519 239.176 552.834 237.263ZM554.548 238.253C558.81 235.793 558.81 231.804 554.548 229.344C550.287 226.884 543.378 226.884 539.116 229.344C534.855 231.804 534.855 235.793 539.116 238.253C543.378 240.713 550.287 240.713 554.548 238.253Z",
    fill: "#C6D6F8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M569.555 261.262C571.686 262.492 571.686 264.486 569.555 265.717C567.425 266.947 563.97 266.947 561.839 265.717C559.709 264.486 559.709 262.492 561.839 261.262C563.97 260.032 567.425 260.032 569.555 261.262Z",
    fill: "#08FFA6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.695 266.954C575.01 265.04 575.01 261.938 571.695 260.025C568.381 258.111 563.007 258.111 559.693 260.025C556.378 261.938 556.378 265.04 559.693 266.954C563.007 268.867 568.381 268.867 571.695 266.954ZM573.41 267.944C577.672 265.484 577.672 261.495 573.41 259.035C569.149 256.575 562.24 256.575 557.978 259.035C553.717 261.495 553.717 265.484 557.978 267.944C562.24 270.404 569.149 270.404 573.41 267.944Z",
    fill: "#C6D6F8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 309.761C417.385 310.991 417.385 312.985 415.255 314.216C413.124 315.446 409.669 315.446 407.539 314.216C405.408 312.985 405.408 310.991 407.539 309.761C409.669 308.531 413.124 308.531 415.255 309.761Z",
    fill: "#08FFA6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.395 315.455C420.709 313.542 420.709 310.44 417.395 308.526C414.08 306.613 408.706 306.613 405.392 308.526C402.078 310.44 402.078 313.542 405.392 315.455C408.706 317.369 414.08 317.369 417.395 315.455ZM419.109 316.445C423.371 313.985 423.371 309.996 419.109 307.536C414.848 305.076 407.939 305.076 403.677 307.536C399.416 309.996 399.416 313.985 403.677 316.445C407.939 318.905 414.848 318.905 419.109 316.445Z",
    fill: "#C6D6F8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M398.104 359.253C400.235 360.483 400.235 362.478 398.104 363.708C395.974 364.938 392.519 364.938 390.388 363.708C388.258 362.478 388.258 360.483 390.388 359.253C392.519 358.023 395.974 358.023 398.104 359.253Z",
    fill: "#C6D6F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.244 364.945C403.558 363.032 403.558 359.929 400.244 358.016C396.929 356.102 391.556 356.102 388.241 358.016C384.927 359.929 384.927 363.032 388.241 364.945C391.556 366.859 396.929 366.859 400.244 364.945ZM401.958 365.935C406.22 363.475 406.22 359.486 401.958 357.026C397.697 354.566 390.788 354.566 386.527 357.026C382.265 359.486 382.265 363.475 386.527 365.935C390.788 368.395 397.697 368.395 401.958 365.935Z",
    fill: "#C6D6F8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M293.522 309.763C295.653 310.994 295.653 312.988 293.522 314.218C291.391 315.448 287.937 315.448 285.806 314.218C283.676 312.988 283.676 310.994 285.806 309.763C287.937 308.533 291.391 308.533 293.522 309.763Z",
    fill: "#08FFA6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.662 315.455C298.977 313.542 298.977 310.44 295.662 308.526C292.348 306.613 286.974 306.613 283.66 308.526C280.345 310.44 280.345 313.542 283.66 315.455C286.974 317.369 292.348 317.369 295.662 315.455ZM297.377 316.445C301.638 313.985 301.638 309.996 297.377 307.536C293.115 305.076 286.206 305.076 281.945 307.536C277.684 309.996 277.684 313.985 281.945 316.445C286.206 318.905 293.115 318.905 297.377 316.445Z",
    fill: "#C6D6F8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M432.569 73.1253C434.699 74.3554 434.699 76.3497 432.569 77.5798C430.438 78.8099 426.983 78.8099 424.853 77.5798C422.722 76.3497 422.722 74.3554 424.853 73.1253C426.983 71.8952 430.438 71.8952 432.569 73.1253Z",
    fill: "#C6D6F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.709 78.8171C438.023 76.9037 438.023 73.8014 434.709 71.8879C431.394 69.9745 426.02 69.9745 422.706 71.8879C419.392 73.8014 419.392 76.9037 422.706 78.8171C426.02 80.7306 431.394 80.7306 434.709 78.8171ZM436.423 79.807C440.685 77.3469 440.685 73.3582 436.423 70.8981C432.162 68.4379 425.253 68.4379 420.991 70.8981C416.73 73.3582 416.73 77.3469 420.991 79.807C425.253 82.2672 432.162 82.2672 436.423 79.807Z",
    fill: "#C6D6F8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.252 38.244L291.905 130.068L305.381 137.849L313.249 117.281L355.861 141.885L363.711 171.529L377.187 179.31L341.978 46.747L327.252 38.244ZM352.224 127.807L334.547 60.5839L316.879 107.399L352.224 127.807Z",
    fill: "#1B1E59"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M390.915 75.002L403.678 82.3713L403.682 194.607L390.919 187.237L390.915 75.002Z",
    fill: "#1B1E59"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.238 42.2918L284.891 134.116L298.367 141.897L306.235 121.329L348.847 145.933L356.698 175.577L370.174 183.358L334.965 50.7948L320.238 42.2918ZM345.209 131.855L327.532 64.6313L309.864 111.446L345.209 131.855Z",
    fill: "url(#paint4_linear_8066_3061)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M383.901 79.0498L396.665 86.4192L396.668 198.655L383.905 191.285L383.901 79.0498Z",
    fill: "url(#paint5_linear_8066_3061)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M320.241 42.2939L327.264 38.251L341.98 46.748L377.07 179.206L370.178 183.74L334.956 50.7903L320.241 42.2939Z",
    fill: "#1B1E59"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M327.518 64.6357L329.783 73.1945L316.882 107.396L309.864 111.454L327.518 64.6357Z",
    fill: "#1B1E59"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M316.879 107.396L342.705 122.315L345.205 131.856L309.869 111.446L316.879 107.396Z",
    fill: "#1B1E59"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M306.233 121.33L310.712 123.911L305.385 137.85L298.369 141.905L306.233 121.33Z",
    fill: "#1B1E59"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M383.9 79.0531L390.917 75.0039L403.68 82.3748V194.613L396.636 198.586V86.4408L383.9 79.0531Z",
    fill: "#1B1E59"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M374.545 238.889L378.74 241.311L378.74 264.829L374.546 262.407L374.545 238.889Z",
    fill: "#272DA7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M378.741 241.312L384.8 237.813L384.799 261.331L378.74 264.829L378.741 241.312Z",
    fill: "#2D47B0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M374.545 238.891L380.604 235.393L384.802 237.816L378.743 241.314L374.545 238.891Z",
    fill: "#272DA7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M391.525 229.084L395.719 231.506L395.72 255.025L391.526 252.603L391.525 229.084Z",
    fill: "#272DA7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M395.721 231.507L401.78 228.009L401.779 251.526L395.72 255.025L395.721 231.507Z",
    fill: "#2D47B0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M391.525 229.087L397.584 225.59L401.782 228.013L395.723 231.511L391.525 229.087Z",
    fill: "#272DA7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M408.506 219.281L412.7 221.703L412.701 245.221L408.507 242.799L408.506 219.281Z",
    fill: "#272DA7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M412.702 221.704L418.76 218.205L418.76 241.723L412.701 245.221L412.702 221.704Z",
    fill: "#2D47B0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M408.506 219.283L414.565 215.785L418.762 218.209L412.704 221.706L408.506 219.283Z",
    fill: "#272DA7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M425.486 209.477L429.681 211.898L429.682 235.417L425.487 232.995L425.486 209.477Z",
    fill: "#272DA7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M429.683 211.9L435.742 208.402L435.741 231.919L429.682 235.417L429.683 211.9Z",
    fill: "#2D47B0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M425.487 209.479L431.546 205.982L435.743 208.405L429.685 211.903L425.487 209.479Z",
    fill: "#272DA7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M442.468 199.673L446.662 202.095L446.663 225.614L442.469 223.192L442.468 199.673Z",
    fill: "#272DA7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M446.664 202.096L452.722 198.598L452.721 222.115L446.663 225.613L446.664 202.096Z",
    fill: "#2D47B0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M442.468 199.676L448.527 196.178L452.724 198.601L446.666 202.099L442.468 199.676Z",
    fill: "#272DA7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M459.449 189.87L463.643 192.292L463.644 215.81L459.449 213.388L459.449 189.87Z",
    fill: "#272DA7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M463.645 192.293L469.704 188.795L469.703 212.312L463.644 215.81L463.645 192.293Z",
    fill: "#2D47B0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M459.449 189.873L465.508 186.375L469.705 188.798L463.647 192.296L459.449 189.873Z",
    fill: "#272DA7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M476.429 180.065L480.624 182.487L480.625 206.006L476.43 203.584L476.429 180.065Z",
    fill: "#272DA7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M480.626 182.488L486.685 178.99L486.684 202.507L480.625 206.005L480.626 182.488Z",
    fill: "#2D47B0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M476.43 180.068L482.489 176.57L486.686 178.993L480.627 182.491L476.43 180.068Z",
    fill: "#272DA7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M317.601 237.8L323.67 241.305L323.671 264.827L317.602 261.323L317.601 237.8Z",
    fill: "#2D47B0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M323.672 241.305L327.868 238.882L327.868 262.397L323.671 264.82L323.672 241.305Z",
    fill: "#272DA7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M317.599 237.802L321.796 235.379L327.869 238.885L323.672 241.308L317.599 237.802Z",
    fill: "#272DA7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M300.62 227.997L306.689 231.501L306.69 255.023L300.621 251.519L300.62 227.997Z",
    fill: "#2D47B0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M306.692 231.501L310.888 229.078L310.888 252.593L306.691 255.016L306.692 231.501Z",
    fill: "#272DA7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M300.618 227.999L304.815 225.576L310.888 229.082L306.691 231.504L300.618 227.999Z",
    fill: "#272DA7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M283.64 218.192L289.709 221.697L289.71 245.219L283.641 241.715L283.64 218.192Z",
    fill: "#2D47B0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M289.711 221.697L293.908 219.274L293.907 242.789L289.711 245.212L289.711 221.697Z",
    fill: "#272DA7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M283.638 218.195L287.834 215.772L293.907 219.278L289.711 221.701L283.638 218.195Z",
    fill: "#272DA7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M266.659 208.389L272.728 211.893L272.729 235.416L266.659 231.912L266.659 208.389Z",
    fill: "#2D47B0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M272.73 211.894L276.927 209.47L276.926 232.986L272.729 235.409L272.73 211.894Z",
    fill: "#272DA7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M266.657 208.391L270.853 205.968L276.926 209.474L272.73 211.897L266.657 208.391Z",
    fill: "#272DA7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M249.678 198.584L255.747 202.089L255.748 225.611L249.678 222.107L249.678 198.584Z",
    fill: "#2D47B0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M255.75 202.089L259.946 199.666L259.945 223.181L255.749 225.604L255.75 202.089Z",
    fill: "#272DA7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M249.676 198.587L253.873 196.164L259.945 199.67L255.749 202.093L249.676 198.587Z",
    fill: "#272DA7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M232.697 188.781L238.766 192.285L238.767 215.807L232.698 212.303L232.697 188.781Z",
    fill: "#2D47B0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M238.769 192.286L242.965 189.863L242.964 213.378L238.768 215.801L238.769 192.286Z",
    fill: "#272DA7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M232.695 188.783L236.892 186.36L242.964 189.866L238.768 192.289L232.695 188.783Z",
    fill: "#272DA7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M215.716 178.978L221.785 182.482L221.786 206.004L215.717 202.5L215.716 178.978Z",
    fill: "#2D47B0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M221.788 182.482L225.984 180.059L225.983 203.574L221.787 205.997L221.788 182.482Z",
    fill: "#272DA7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M215.714 178.979L219.911 176.557L225.984 180.063L221.787 182.485L215.714 178.979Z",
    fill: "#272DA7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8066_3061",
    x1: 97.4671,
    y1: 245.134,
    x2: 529.077,
    y2: 245.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8066_3061",
    x1: 440.978,
    y1: 126.276,
    x2: 97.0271,
    y2: 229.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8066_3061",
    x1: 494.783,
    y1: 177.582,
    x2: 206.036,
    y2: 175.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8066_3061",
    x1: 417.04,
    y1: 119.075,
    x2: 273.402,
    y2: 155.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8066_3061",
    x1: 327.529,
    y1: 46.5015,
    x2: 278.929,
    y2: 130.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#05F29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8066_3061",
    x1: 390.283,
    y1: 82.7345,
    x2: 341.683,
    y2: 166.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#05F29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDataAnalyticsPlattform);
export default __webpack_public_path__ + "static/media/Img_DataAnalyticsPlattform.425d975951a8ee2def8821211ef1bf4b.svg";
export { ForwardRef as ReactComponent };